import { Logger, NumberUtils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { GameManager } from "./GameManager";
import { GameData } from "../Channels/Common/Datas/GameData";
import { DataManager } from "./DataManager";
import { ModuleManager } from "./ModuleManager";
import { AppContext } from "../../Common/AppContext";
import { HtmlDenomContainerElement } from "../HTMLComponents/Custom/HtmlDenomContainerElement";
import { BalanceManager } from "./BalanceManager";
import { HtmlBetSelectorContainerElement } from "../HTMLComponents/Custom/HtmlBetSelectorContainerElement";
import { HtmlController } from "../HTMLComponents/HtmlController";
import { HtmlBetSelectorContainerElement2 } from "../HTMLComponents/Custom/HtmlBetSelectorContainerElement2";
import { Languages } from "../Utils/Languages";
import { FreeRoundBonus } from "../Channels/Common/Bonuses/FreeRoundBonus";
import { BetHigherThanMinDialog } from "../Channels/Common/Dialogs/BetHigherThanMinDialog";

var SpinBet = Communication.Game.SpinBet;
var BetType = Communication.Game.BetType;

export class BetManager {
    static CoinSize: number;
    static CoinCount: number;
    static Bet: number;

    static DigitCount: number = 1;

    static Coins: { [coinSize: number]: Array<number> };
    static TotalBets: Array<number>;

    static DenomContainer: HtmlDenomContainerElement;
    static CoinCountContainer: HtmlBetSelectorContainerElement;
    static BetContainer: HtmlBetSelectorContainerElement2;

    static minBet: boolean = false;
    static maxBet: boolean = false;

    static initializeBet(): void {
        if (AppContext.current.getHideAmounts()) {
            this.hideValues(true);
        }
        if (GameManager.baseResponse.initData != null) {
            if (
                GameManager.baseResponse.initData.betSettings != null &&
                GameManager.baseResponse.initData.betSettings.totalBets != null
            ) {
                BetManager.TotalBets = GameManager.baseResponse.initData.betSettings.totalBets;
            }

            if (
                GameManager.baseResponse.initData.betSettings != null &&
                GameManager.baseResponse.initData.betSettings.coins != null
            ) {
                BetManager.Coins = GameManager.baseResponse.initData.betSettings.coins;
            }

            if (
                GameManager.baseResponse.initData.lastBet != null &&
                GameManager.baseResponse.initData.lastBet.betType === BetType.Total
            ) {
                if (
                    GameManager.baseResponse.initData.lastBet.totalBet != null &&
                    !AppContext.gameConfiguration.UseCoins
                ) {
                    if (
                        BetManager.Bet != null &&
                        BetManager.Bet !== GameManager.baseResponse.initData.lastBet.totalBet
                    ) {
                        ModuleManager.initNewBet();
                    } else {
                        ModuleManager.initNewBet(false);
                    }
                    BetManager.Bet = BetHigherThanMinDialog.getGameStartedWithoutFeature()
                        ? BetManager.TotalBets[0]
                        : GameManager.baseResponse.initData.lastBet.totalBet;
                    BetManager.updateBetPosition();
                    DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
                } else {
                    if (!DataManager.GameRoundClosed) {
                        if (GameManager.baseResponse.initData.lastBet.coinSize != null) {
                            BetManager.CoinSize = GameManager.baseResponse.initData.lastBet.coinSize;
                            DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
                        }
                        if (GameManager.baseResponse.initData.lastBet.coinCount != null) {
                            BetManager.CoinCount = parseInt(
                                GameManager.baseResponse.initData.lastBet.coinCount.toString(),
                            );
                            DataManager.updateGameDataFromModule(
                                GameData.DataCointCount,
                                BetManager.CoinCount.toString(),
                            );
                        }
                        if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
                            BetManager.Bet = parseFloat(
                                NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount),
                            );
                            DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
                        }
                        BalanceManager.recalculateDenomBalance();
                    } else if (AppContext.current.getDenomination() != null && BetManager.Coins != null) {
                        if (BetManager.Coins[AppContext.current.getDenomination()] != null) {
                            BetManager.changeDenom(AppContext.current.getDenomination(), true);
                        } else {
                            BetManager.changeDefaultDenom();
                        }
                    } else {
                        BetManager.changeDefaultDenom();
                    }
                    if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
                        BetManager.Bet = parseFloat(NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
                        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
                    }
                }
            }

            BetManager.DigitCount = String(parseInt(String(BetManager.Bet * 100))).length;

            if (BetManager.DenomContainer != null) {
                BetManager.DenomContainer.addValues();
            }

            if (BetManager.CoinCountContainer != null) {
                BetManager.CoinCountContainer.addValues();
            }

            if (BetManager.BetContainer != null) {
                BetManager.BetContainer.addValues();
            }
        }
    }

    static changeBet(decrease: boolean = false, max: boolean = false, cycle: boolean = false): void {
        BetHigherThanMinDialog.closeDialog(true);
        if (DataManager.GameRoundClosed) {
            FreeRoundBonus.enableUi();
        }

        BetManager.unHideValues();

        if (AppContext.gameConfiguration.UseCoins) {
            if (cycle) {
                BetManager.cycleCoinCount();
                return;
            } else if (max) {
                BetManager.maxCoinCount();
                return;
            }
        }

        var bonus: number = parseFloat(DataManager.getDataById(GameData.DataBalanceBonus));
        var real: number = parseFloat(DataManager.getDataById(GameData.DataBalanceReal));

        if (BetManager.Bet != null && BetManager.TotalBets != null && BetManager.TotalBets.length > 0) {
            var index: number;
            for (var i: number = 0; i < BetManager.TotalBets.length; i++) {
                if (BetManager.Bet === BetManager.TotalBets[i]) {
                    index = i;
                }
            }
            if (index != null) {
                if (decrease) {
                    if (index === 0) {
                        if (cycle) {
                            index = BetManager.TotalBets.length - 1;
                        }
                    } else {
                        index--;
                    }
                } else {
                    if (max) {
                        var findMax: boolean = false;

                        if (!findMax) {
                            for (var jj: number = BetManager.TotalBets.length - 1; jj >= 0; jj--) {
                                if (BetManager.TotalBets[jj] <= bonus && findMax === false) {
                                    findMax = true;
                                    index = jj;
                                }
                                if (BetManager.TotalBets[jj] <= real && findMax === false) {
                                    findMax = true;
                                    index = jj;
                                }
                            }
                        }
                    } else {
                        if (index === BetManager.TotalBets.length - 1) {
                            if (cycle) {
                                index = 0;
                            }
                        } else {
                            index++;
                        }
                    }
                }

                BetManager.Bet = BetManager.TotalBets[index];

                if (bonus != null) {
                    if (bonus >= BetManager.Bet) {
                        ModuleManager.changeBetColor(true);
                    } else {
                        ModuleManager.changeBetColor();
                    }
                }

                BetManager.DigitCount = String(parseInt(String(BetManager.Bet * 100))).length;

                DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
                DataManager.updateDataElement(GameData.DataBet);
                Platforms.Platforms.bet({
                    totalBet: BetManager.Bet,
                    maxBetAction: max,
                    userAction: DataManager.getTrustedUserAction("BET_CHANGE"),
                });
                BetManager.updateBetPosition();
            }
        }
        BalanceManager.poolingBalance();
    }

    static sortNumber(a: any, b: any) {
        return a - b;
    }

    static changeDefaultDenom(): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null) {
            let lowestDenom: number;
            for (let key in BetManager.Coins) {
                if (lowestDenom == null) {
                    lowestDenom = parseFloat(key);
                } else {
                    if (parseFloat(key) < lowestDenom) {
                        lowestDenom = parseFloat(key);
                    }
                }
            }

            BetManager.CoinSize = lowestDenom;
            AppContext.current.setDenomination(BetManager.CoinSize);

            BetManager.Coins[lowestDenom].sort(BetManager.sortNumber);

            // let found: boolean = false;
            // for(let i: number = 0; i < BetManager.Coins[value].length; i++) {
            //     if(BetManager.Coins[value][i] === BetManager.CoinCount) {
            //         found = true;
            //     }
            // }
            //
            // if(!found) {
            //     BetManager.CoinCount = BetManager.Coins[value][0];
            // }

            BetManager.CoinCount = BetManager.Coins[lowestDenom][0];

            DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
            DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
            BetManager.Bet = parseFloat(NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
            DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());

            DataManager.updateDataElement(GameData.DataCoinSize);
            DataManager.updateDataElement(GameData.DataCointCount);
            DataManager.updateDataElement(GameData.DataBet);
            Platforms.Platforms.bet({ totalBet: BetManager.Bet });

            if (BetManager.CoinCountContainer != null) {
                BetManager.CoinCountContainer.addValues();
            }
            BalanceManager.recalculateDenomBalance();
        }
    }

    static changeDenom(value: number, init: boolean = false): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null && BetManager.Coins[value] != null) {
            BetManager.CoinSize = value;
            AppContext.current.setDenomination(BetManager.CoinSize);

            BetManager.Coins[value].sort(BetManager.sortNumber);

            if (!init && BetManager.CoinCount != null && !AppContext.gameConfiguration.ResetCoinCountOnDenomChange) {
                let found: boolean = false;
                let coinCount: number = BetManager.CoinCount;
                for (let i: number = 0; i < BetManager.Coins[value].length; i++) {
                    if (BetManager.Coins[value][i] <= BetManager.CoinCount) {
                        found = true;
                        coinCount = BetManager.Coins[value][i];
                    }
                }

                if (!found) {
                    BetManager.CoinCount = BetManager.Coins[value][0];
                } else {
                    BetManager.CoinCount = coinCount;
                }
            } else {
                BetManager.CoinCount = BetManager.Coins[value][0];
            }

            DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
            DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
            BetManager.Bet = parseFloat(NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
            DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());

            DataManager.updateDataElement(GameData.DataCoinSize);
            DataManager.updateDataElement(GameData.DataCointCount);
            DataManager.updateDataElement(GameData.DataBet);
            Platforms.Platforms.bet({ totalBet: BetManager.Bet });

            if (BetManager.CoinCountContainer != null) {
                BetManager.CoinCountContainer.addValues();
            }
            BalanceManager.recalculateDenomBalance();
        }

        if (DataManager.HelpDataGameLimit != 0) {
            if (
                AppContext != null &&
                AppContext.gameConfiguration != null &&
                AppContext.gameConfiguration.UseCoins &&
                BetManager.CoinSize != null
            ) {
                DataManager.updateGameDataFromModule(
                    GameData.DataHelpGameLimit,
                    parseInt(
                        NumberUtils.devide(DataManager.HelpDataGameLimit, BetManager.CoinSize).toString(),
                    ).toString(),
                );
                DataManager.updateDataElement(
                    GameData.DataHelpGameLimit,
                    parseInt(
                        NumberUtils.devide(DataManager.HelpDataGameLimit, BetManager.CoinSize).toString(),
                    ).toString(),
                );
            }
        }

        if (DataManager.HelpDataGambleLimit != 0) {
            if (
                AppContext != null &&
                AppContext.gameConfiguration != null &&
                AppContext.gameConfiguration.UseCoins &&
                BetManager.CoinSize != null
            ) {
                DataManager.updateGameDataFromModule(
                    GameData.DataHelpGambleLimit,
                    parseInt(
                        NumberUtils.devide(DataManager.HelpDataGambleLimit, BetManager.CoinSize).toString(),
                    ).toString(),
                );
                DataManager.updateDataElement(
                    GameData.DataHelpGambleLimit,
                    parseInt(
                        NumberUtils.devide(DataManager.HelpDataGambleLimit, BetManager.CoinSize).toString(),
                    ).toString(),
                );
            }
        }
    }

    static changeBetByValue(value: number): void {
        BetManager.unHideValues();
        var bonus: number = parseFloat(DataManager.getDataById(GameData.DataBalanceBonus));
        BetManager.Bet = value;

        if (bonus != null) {
            if (bonus >= BetManager.Bet) {
                ModuleManager.changeBetColor(true);
            } else {
                ModuleManager.changeBetColor();
            }
        }

        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
        DataManager.updateDataElement(GameData.DataBet);
        Platforms.Platforms.bet({ totalBet: BetManager.Bet });
        BetManager.updateBetPosition();
    }

    static changeCoinCount(value: number): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null) {
            if (BetManager.CoinSize != null) {
                BetManager.CoinCount = value;
                DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
                DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
                BetManager.Bet = parseFloat(NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
                DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());

                DataManager.updateDataElement(GameData.DataCoinSize);
                DataManager.updateDataElement(GameData.DataCointCount);
                DataManager.updateDataElement(GameData.DataBet);
                Platforms.Platforms.bet({ totalBet: BetManager.Bet });
            }
        }
    }

    static cycleCoinCount(): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null) {
            if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
                let index: number = 0;
                let coinSizes: Array<number> = [];
                for (let i: number = 0; i < BetManager.Coins[BetManager.CoinSize].length; i++) {
                    coinSizes.push(BetManager.Coins[BetManager.CoinSize][i]);
                }
                coinSizes.sort(BetManager.sortNumber);
                for (let i: number = 0; i < coinSizes.length; i++) {
                    if (BetManager.CoinCount === coinSizes[i]) {
                        index = i;
                    }
                }

                if (coinSizes[index + 1] != null) {
                    BetManager.CoinCount = coinSizes[index + 1];
                } else {
                    BetManager.CoinCount = coinSizes[0];
                }

                DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
                DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
                BetManager.Bet = parseFloat(NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
                DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());

                DataManager.updateDataElement(GameData.DataCoinSize);
                DataManager.updateDataElement(GameData.DataCointCount);
                DataManager.updateDataElement(GameData.DataBet);
                Platforms.Platforms.bet({ totalBet: BetManager.Bet });
            }
        }
    }

    static maxCoinCount(): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null) {
            if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
                let credit: number = parseFloat(DataManager.getDataById(GameData.DataBalanceReal));
                let coinCount: number = BetManager.CoinCount;

                BetManager.Coins[BetManager.CoinSize].sort(BetManager.sortNumber);

                for (let i: number = 0; i < BetManager.Coins[BetManager.CoinSize].length; i++) {
                    let bet: number = parseFloat(
                        NumberUtils.multiply(BetManager.CoinSize, BetManager.Coins[BetManager.CoinSize][i]),
                    );
                    if (credit >= bet) {
                        coinCount = BetManager.Coins[BetManager.CoinSize][i];
                    }
                }

                BetManager.CoinCount = coinCount;

                DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
                DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
                BetManager.Bet = parseFloat(NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
                DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());

                DataManager.updateDataElement(GameData.DataCoinSize);
                DataManager.updateDataElement(GameData.DataCointCount);
                DataManager.updateDataElement(GameData.DataBet);
                Platforms.Platforms.bet({ totalBet: BetManager.Bet });
            }
        }
    }

    static updateBetPosition(): void {
        if (BetManager.TotalBets != null) {
            for (let i: number = 0; i < BetManager.TotalBets.length; i++) {
                if (BetManager.Bet === BetManager.TotalBets[i]) {
                    if (i <= 0) {
                        BetManager.minBet = true;
                        BetManager.maxBet = false;
                    } else if (i >= BetManager.TotalBets.length - 1) {
                        BetManager.minBet = false;
                        BetManager.maxBet = true;
                    } else {
                        BetManager.minBet = false;
                        BetManager.maxBet = false;
                    }

                    DataManager.updateGameDataFromModule(
                        GameData.DataBetPosition,
                        i + 1 + "/" + BetManager.TotalBets.length,
                    );
                    DataManager.updateDataElement(GameData.DataBetPosition);
                }
            }
        }
    }

    static unHideValues(credit: boolean = false): void {
        for (let i = 0; i < HtmlController.HideButtons.length; i++) {
            HtmlController.HideButtons[i].unHide(credit);
        }
    }

    static hideValues(credit: boolean = false): void {
        for (let i = 0; i < HtmlController.HideButtons.length; i++) {
            HtmlController.HideButtons[i].hide(credit);
        }
    }

    static createBetForSpin(): Communication.Game.SpinBet {
        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null && BetManager.CoinCount != null) {
            return new SpinBet(BetType.Total, BetManager.CoinSize, BetManager.CoinCount, null, null);
        } else {
            return new SpinBet(BetType.Total, null, null, null, BetManager.Bet);
        }
    }

    private static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("BetManager", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/BetManager.ts
 **/